import { useCallback } from 'react'
import { useConfig } from '~/domains/configuration/queries/config'

export const useResolveStorageUrl = (): ((url: string) => string) => {
  const { data: legacyUrl = '' } = useConfig('organization.legacy_url')

  return useCallback(
    (url: string): string =>
      url.startsWith('/admin') ? `${legacyUrl}${url}` : url,
    [legacyUrl]
  )
}
